import { useCurrentUser } from '@tyndo/hooks';

/**
 * Single source of truth for the current principal's roles in the shell.
 *
 * Roles live in the decoded JWT (`useCurrentUser().roles`), NOT on the
 * shell-facing `useAuth().user` object (which only carries name/email) —
 * AppShell / TopBar previously read a loosely-cast `user.roles` and always
 * got [].
 *
 * There is deliberately no localStorage mirror of the roles. One used to
 * exist ('tyndo.auth.roles') so the shell could pass a principal's roles to
 * the entitlement evaluator from the client. Entitlements are now answered by
 * a self-scoped route that derives roles from the authenticated principal on
 * the SERVER, so a client-writable roles key would be both unread and, sitting
 * next to an authorization decision, actively misleading.
 */

/** Read the decoded JWT roles for RBAC nav / admin gating. */
export function useAuthRoles(): string[] {
  const user = useCurrentUser();
  return user?.roles ?? [];
}
